import React from 'react';
import styled from 'styled-components';

const MapContainer = styled.div`
  width: 100%;
  height: ${props => props.$height || '250px'};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;

  iframe {
    width: 100%;
    height: 500px;
    filter: grayscale(0.2) contrast(1.1);
    transition: all 0.3s ease;

    &:hover {
      filter: grayscale(0);
    }
  }

  @media (max-width: 768px) {
    height: 300px;
  }
`;

const MapSection = ({ height }) => {
  return (
    <MapContainer $height={height}>
      <iframe
        title="KM Nail Hair Salon Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.5449511039865!2d106.59213787607575!3d10.846093789306979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752b00080970cf%3A0xd88c01c3a0f50b56!2sKM%20Nail%20Hair%20Salon!5e0!3m2!1sen!2s!4v1769849621495!5m2!1sen!2s"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </MapContainer>
  );
};

export default MapSection;